import { combineReducers } from 'redux';

import * as Goals from './goals';
import * as Emails from './emails';
import * as Retirement from './retirement';
import * as Debt from './debt';
import * as Currency from './currency';
import * as Budget from './budget';
import * as Diagnostic from './diagnostic';
import * as Result from './result';

export {
  Goals,
  Emails,
  Retirement,
  Debt,
  Currency,
  Budget,
  Diagnostic,
  Result,
};

const Reducer = combineReducers({
  goals: Goals.Reducer,
  emails: Emails.Reducer,
  retirement: Retirement.Reducer,
  debt: Debt.Reducer,
  currency: Currency.Reducer,
  budget: Budget.Reducer,
  diagnostic: Diagnostic.Reducer,
  result: Result.Reducer,
});

export default Reducer;
